const getId = (value) => value?.id || value

export const getBatchChainIds = (batches = [], batchId) => {
  const byId = new Map(batches.map((batch) => [getId(batch), batch]))
  const selected = byId.get(batchId)
  if (!selected) return [batchId].filter(Boolean)

  const rootId = selected.originalBatchId || selected.id
  const related = batches.filter(
    (batch) => (batch.originalBatchId || batch.id) === rootId,
  )
  const ordered = []
  let parentId = rootId
  while (parentId) {
    const current = related.find(
      (batch) =>
        batch.id === parentId || (!batch.parentBatchId && batch.id === rootId),
    )
    if (!current || ordered.includes(current.id)) break
    ordered.push(current.id)
    const child = related.find((batch) => batch.parentBatchId === current.id)
    parentId = child?.id
  }
  related.forEach((batch) => {
    if (!ordered.includes(batch.id)) ordered.push(batch.id)
  })
  if (!ordered.includes(selected.id)) ordered.push(selected.id)
  return ordered.filter(Boolean)
}

const getD0Identity = (row) =>
  row.originalDZeroId ||
  row.dzeroOriginal ||
  row.originalDZero?.id ||
  row._raw?.originalDZero_id ||
  row.id

const getBatchId = (row) => row.loteId || row.batchId || row._raw?.batch_id

export const mergeBatchCows = (rows = [], batchOrder = []) => {
  const order = new Map(batchOrder.map((id, index) => [id, index]))
  const byCow = new Map()

  rows.forEach((row) => {
    const identity = getD0Identity(row) || row.codVaca
    if (!identity) return
    const current = byCow.get(identity)
    const currentRank = current ? order.get(getBatchId(current)) || 0 : -1
    const nextRank = order.get(getBatchId(row)) || 0
    const shouldReplace =
      !current ||
      nextRank > currentRank ||
      (nextRank === currentRank &&
        (row.updatedAt?.valueOf?.() || row.createdAt?.valueOf?.() || 0) >=
          (current.updatedAt?.valueOf?.() ||
            current.createdAt?.valueOf?.() ||
            0))
    if (shouldReplace) byCow.set(identity, row)
  })

  return [...byCow.values()]
}

export const getScopeRows = (rows = [], scope = 'batch') => {
  if (scope === 'current-dg') return rows.filter((row) => row.isCurrentDg)
  if (scope === 'pending-batch') return rows.filter((row) => !row.isSaved)
  if (scope === 'pending-current-dg')
    return rows.filter((row) => row.isCurrentDg && !row.isSaved)
  return rows
}

export const EXPORT_SCOPES = [
  { value: 'batch', label: 'Lote completo' },
  { value: 'current-dg', label: 'IATF atual' },
  { value: 'pending-batch', label: 'Pendentes do lote' },
  { value: 'pending-current-dg', label: 'Pendentes da IATF atual' },
]
